import {
  ANALYTICS_EVENT,
  ANALYTICS_PAGEVIEW,
} from '../constants';

import analytics from '../analytics';

const reducer = (state = analytics, action) => {
  switch (action.type) {
    case ANALYTICS_EVENT:
      analytics.trackEvent(action.payload);
      break;

    case ANALYTICS_PAGEVIEW:
      analytics.trackVirtualPageview(action.payload);
      break;

    default:
      break;
  }

  return state;
};

export default reducer;
